import {Component, HostListener, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {

  @Input() title?: string | undefined = '';
  @Input() open: boolean = false;
  @Input() closeOnClickOutside: boolean = false;

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.open) {
      this.closeDialog();
    }
  }

  public openDialog(): void {
    this.open = true;
  }

  public closeDialog(): void {
    this.open = false;
  }

  public onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closeDialog();
    }
  }
}
